import React, { useEffect, useState } from 'react'; // useStateを追加
import { Container, Card, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { db } from '../firebase'; // dbをインポート
import { doc, onSnapshot } from 'firebase/firestore'; // onSnapshotを追加

function AdminMenu() {
  // ★追加：メンテナンス状態を管理するState
  const [isMaintenance, setIsMaintenance] = useState(false);

  useEffect(() => {
    document.title = '管理者メニュー | My Order System';
  }, []);

  // ★追加：メンテナンス状態のリアルタイム監視
  useEffect(() => {
    const sessionDocRef = doc(db, "system_settings", "session_control");
    const unsubscribe = onSnapshot(sessionDocRef, (docSnap) => {
      setIsMaintenance(docSnap.exists());
    }, (err) => {
      console.warn("Maintenance listener error:", err);
    });
    return () => unsubscribe();
  }, []);

  return (
    <main>
      <Container className="my-4">
        <Card className="shadow-sm">
          <Card.Header as="h2" className="p-3">
            管理者メニュー
          </Card.Header>
          <Card.Body className="p-4">
            <p className="lead">
              管理者専用の機能一覧です。
            </p>
            <Row className="g-3 mt-3">
              <Col xs={12} md={6}>
                <Link to="/admin/all-orders" className="btn w-100 shadow-sm text-white fw-bold" style={{ backgroundColor: '#24639c' }}>
                  注文履歴
                </Link>
              </Col>
              <Col xs={12} md={6}>
                <Link to="/admin/users" className="btn btn-outline-secondary w-100 shadow">
                  ユーザー管理
                </Link>
              </Col>
              
              {/* ★修正：ログイン管理ボタンの色を動的に変更 */}
              <Col xs={12} md={4}>
                <Link 
                  to="/admin/login-management" 
                  className={`btn w-100 shadow ${isMaintenance ? 'btn-danger fw-bold' : 'btn-outline-secondary'}`}
                >
                  {isMaintenance ? 'ログイン管理 (メンテ中)' : 'ログイン管理'}
                </Link>
              </Col>

              <Col xs={12} md={4}>
                <Link to="/admin/products" className="btn btn-outline-secondary w-100 shadow">
                  商品登録
                </Link>
              </Col>
              <Col xs={12} md={4}>
                <Link to="/admin/news" className="btn btn-outline-secondary w-100 shadow">
                  お知らせ管理
                </Link>
              </Col>
              <Col xs={12} md={4}>
                <Link to="/admin/holidays" className="btn btn-outline-secondary w-100 shadow">
                  休日管理
                </Link>
              </Col>
              <Col xs={12} md={4}>
                <Link to="/admin/settings" className="btn btn-outline-secondary w-100 shadow">
                  システム設定
                </Link>
              </Col>
              <Col xs={12} md={4}>
                <Link to="/admin/ranking" className="btn btn-outline-secondary w-100 shadow">
                  実績管理
                </Link>
              </Col>
              <Col xs={12} md={4}>
                <Link to="/admin/login-logs" className="btn btn-outline-secondary w-100 shadow">
                  ログイン履歴
                </Link>
              </Col>
              <Col xs={12} md={4}>
                <Link to="/admin/delivery-estimate" className="btn btn-outline-secondary w-100 shadow">
                  納期目安の管理
                </Link>
              </Col>
            </Row>
            <hr className="my-4" />
            <Link to="/mainmenu">
              メインメニューに戻る
            </Link>
          </Card.Body>
        </Card>
      </Container>
    </main>
  );
}

export default AdminMenu;